export default __webpack_public_path__ + "static/media/sourcegraph.3480c2c6.svg";